import React from 'react';
import { Link } from 'react-router-dom';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';

const HeroSection = () => {
  const { data: homePage, isLoading, error } = usePageData('homePage');

  if (isLoading) {
    return (
      <section className="hero">
        <div className="hero-text">
          <LoadingSkeleton type="text" count={3} />
          <div className="buttons">
            <LoadingSkeleton type="text" count={1} />
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="hero">
        <div className="hero-text">
          <div className="error-message">
            <p>Failed to load hero section. Please try again later.</p>
          </div>
        </div>
      </section>
    );
  }

  if (!homePage) return null;

  // Function to properly handle image URLs from Django admin
  const getImageUrl = (url) => {
    if (!url) return '/default-hero.jpg';
    
    // If it's already a full URL, return as is
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    // If it's a relative path, prepend the backend URL
    if (url.startsWith('/')) {
      return `http://localhost:8000${url}`;
    }
    
    // If it's just a filename, construct the path
    return `http://localhost:8000/media/home/hero/${url}`;
  };

  return (
    <section className="hero">
      <div className="hero-text">
        <h1 dangerouslySetInnerHTML={{ __html: homePage.hero_title }} />
        <p>{homePage.hero_subtitle}</p>
        
        <div className="buttons">
          <Link to="/templates">
            <button className="btn-primary">{homePage.hero_button_text}</button>
          </Link>
        </div>
        
        <div className="stats">
          {homePage.stats?.map((stat, index) => (
            <div key={index}>
              <h3>{stat.value}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
      
      <div className="hero-image">
        {homePage.hero_image_url && (
          <img 
            src={getImageUrl(homePage.hero_image_url)} 
            alt="Resume Illustration" 
            loading="lazy"
            onError={(e) => {
              e.target.src = '/default-hero.jpg';
              e.target.alt = 'Default hero image';
            }}
          />
        )}
      </div>
    </section>
  );
};

export default HeroSection;